import { render, staticRenderFns } from "./BusinessContinueYN.vue?vue&type=template&id=7ff4fae5"
import script from "./BusinessContinueYN.vue?vue&type=script&lang=js"
export * from "./BusinessContinueYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports